export default __webpack_public_path__ + "static/media/partnership.33531750.png";